import script from "./CardRound.vue?vue&type=script&setup=true&lang=js"
export * from "./CardRound.vue?vue&type=script&setup=true&lang=js"

import "./CardRound.vue?vue&type=style&index=0&id=41c3081d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c3081d"]])

export default __exports__